import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { AuthService } from '../service/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private _auth: AuthService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap((event: HttpEvent<unknown>) => {
        if (event instanceof HttpResponse && event.body) {
          const body = event.body as {
            data?: unknown;
            errors?: Array<{ code?: string; message?: string }>;
          };
          if (!body.errors?.length || body.data) {
            return;
          }
          const graphqlError = body.errors[0];
          const errorCode = graphqlError?.code;
          const errorMessage = graphqlError?.message || '';
          if (
            errorCode === 'INVALID_SESSION'
            || errorMessage.includes('INVALID_SESSION')
            || errorMessage.includes('Missing authorization token')
            || errorMessage.includes('Unauthorized')
          ) {
            this._auth.logout();
          }
        }
      })
    );
  }
}
